import _typeof from "@babel/runtime/helpers/typeof";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isPureObject } from '../../../common/util/type-check';
/**
 * @typedef {object} GQLMetadata
 * @property {string} operationName Name of the operation
 * @property {string} operationType Type of the operation
 * @property {string} operationFramework Framework responsible for the operation
 */

/**
 * Parses and returns the graphql metadata from a network request. If the network
 * request is not a graphql call, undefined will be returned.
 * @param {object|string} body Ajax request body
 * @param {string} query Ajax request query param string
 * @returns {GQLMetadata | undefined}
 */

export function parseGQL() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      body = _ref.body,
      query = _ref.query;

  if (!body && !query) return;

  try {
    var gqlBody = parseBatchGQL(parseGQLContents(body));
    if (gqlBody) return gqlBody;
    var gqlQuery = parseSingleGQL(parseGQLQueryString(query));
    if (gqlQuery) return gqlQuery;
  } catch (err) {// parsing failed, return undefined
  }
}
/**
 * @param {string|Object} gql The GraphQL object body sent to a GQL server
 * @returns {GQLMetadata}
 */

function parseSingleGQL(contents) {
  if (_typeof(contents) !== 'object' || !contents.query || typeof contents.query !== 'string') return;
  /** parses gql query string and returns [fullmatch, type match, name match] */

  var matches = contents.query.trim().match(/^(query|mutation|subscription)\s?(\w*)/);
  var operationType = matches === null || matches === void 0 ? void 0 : matches[1];
  if (!operationType) return;
  var operationName = contents.operationName || (matches === null || matches === void 0 ? void 0 : matches[2]) || 'Anonymous';
  return {
    operationName: operationName,
    // the operation name of the indiv query
    operationType: operationType,
    // query, mutation, or subscription,
    operationFramework: 'GraphQL'
  };
}

function parseBatchGQL(contents) {
  if (!contents) return;
  if (!Array.isArray(contents)) contents = [contents];
  var opNames = [];
  var opTypes = [];

  var _iterator = _createForOfIteratorHelper(contents),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var content = _step.value;
      var operation = parseSingleGQL(content);
      if (!operation) continue;
      opNames.push(operation.operationName);
      opTypes.push(operation.operationType);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (!opTypes.length) return;
  return {
    operationName: opNames.join(','),
    // the operation name of the indiv query -- joined by ',' for batched results
    operationType: opTypes.join(','),
    // query, mutation, or subscription -- joined by ',' for batched results
    operationFramework: 'GraphQL'
  };
}

function parseGQLContents(gqlContents) {
  var contents;
  if (!gqlContents || typeof gqlContents !== 'string' && _typeof(gqlContents) !== 'object') return;else if (typeof gqlContents === 'string') contents = JSON.parse(gqlContents);else contents = gqlContents;
  if (!isPureObject(contents) && !Array.isArray(contents)) return;
  var isValid = false;
  if (Array.isArray(contents)) isValid = contents.some(function (x) {
    return validateGQLObject(x);
  });else isValid = validateGQLObject(contents);
  if (!isValid) return;
  return contents;
}

function parseGQLQueryString(gqlQueryString) {
  if (!gqlQueryString || typeof gqlQueryString !== 'string') return;
  var params = new URLSearchParams(gqlQueryString);
  return parseGQLContents(Object.fromEntries(params));
}

function validateGQLObject(obj) {
  return !(_typeof(obj) !== 'object' || !obj.query || typeof obj.query !== 'string');
}